module.exports = __webpack_public_path__ + "static/media/unnamed.bb3c1c54.png";